/**
 * PURPOSE: Confirmar la restauración del sorteo de países del evento 17.
 * RESPONSIBILITIES: Mostrar la advertencia y delegar confirmar/cancelar sin lógica HTTP.
 * COLLABORATORS: SorteoArea2.jsx y MUI Joy.
 * ROUTE: frontend/src/area/SorteoArea/components/ConfirmUndoCountryDrawModal.jsx
 */
import React from "react";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import Button from "@mui/joy/Button";

const Spinner = () => (
  <svg
    className="h-4 w-4 animate-spin"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8v4l4-4-4-4v4a12 12 0 00-12 12h4z"
    />
  </svg>
);

export default function ConfirmUndoCountryDrawModal({
  open,
  loading,
  onCancel,
  onConfirm,
}) {
  return (
    <Modal open={open} onClose={loading ? undefined : onCancel}>
      <ModalDialog sx={{ width: "min(92vw, 500px)", borderRadius: "16px" }}>
        <ModalClose disabled={loading} />
        <DialogTitle>Deshacer sorteo</DialogTitle>
        <DialogContent>
          <p className="text-sm leading-6 text-slate-600">
            Se restaurarán los nombres y logos originales de las estaciones.
          </p>
          <p className="mt-2 text-sm font-semibold leading-6 text-slate-700">
            El cambio también se reflejará en los partidos ya creados en la
            llave de eliminación.
          </p>
        </DialogContent>

        <div className="mt-3 flex justify-end gap-2">
          <Button
            variant="plain"
            color="neutral"
            onClick={onCancel}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            variant="soft"
            color="danger"
            onClick={onConfirm}
            disabled={loading}
            startDecorator={loading ? <Spinner /> : null}
          >
            {loading ? "Deshaciendo..." : "Deshacer sorteo"}
          </Button>
        </div>
      </ModalDialog>
    </Modal>
  );
}
